import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import MainLayout from "@/components/feature/MainLayout";
import AiImprovement from "@/pages/services/ai-improvement/page";
import AiOperation from "@/pages/services/ai-operation/page";
import AiMarketing from "@/pages/services/ai-marketing/page";
import SystemDevelopment from "@/pages/services/system-development/page";
import AiSecurity from "@/pages/services/ai-security/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import BlogList from "@/pages/blog/page";
import BlogDetail from "@/pages/blog/detail/page";
import Contact from "@/pages/contact/page";
import Thanks from "@/pages/contact/thanks/page";
import Company from "@/pages/company/page";
import AdminLogin from "@/pages/admin/login/page";
import AdminDashboard from "@/pages/admin/page";

const routes: RouteObject[] = [
  {
    element: <MainLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/services/ai-improvement/", element: <AiImprovement /> },
      { path: "/services/ai-operation/", element: <AiOperation /> },
      { path: "/services/ai-marketing/", element: <AiMarketing /> },
      { path: "/services/system-development/", element: <SystemDevelopment /> },
      { path: "/services/ai-security/", element: <AiSecurity /> },
      { path: "/news/", element: <NewsList /> },
      { path: "/news/:slug/", element: <NewsDetail /> },
      { path: "/blog/", element: <BlogList /> },
      { path: "/blog/:slug/", element: <BlogDetail /> },
      { path: "/contact/", element: <Contact /> },
      { path: "/contact/thanks/", element: <Thanks /> },
      { path: "/company/", element: <Company /> },
    ],
  },
  { path: "/admin/login", element: <AdminLogin /> },
  { path: "/admin", element: <AdminDashboard /> },
  { path: "/404", element: <NotFound /> },
  { path: "*", element: <NotFound /> },
];

export default routes;